<template>
  <div class="subpages-tabs">

    <!--  DESKTOP  -->
    <div class="subpages-tabs__navs d-sm-none">
      <div class="subpages-tabs__navs-inner">
        <router-link-modified v-for="item in routes"
                              :key="item.id"
                              :to="item.route"
                              :class="{_active: isRouteNameMixin(item.route.name)}"
                              class="subpages-tabs__nav-btn">
          <span>{{ item.name }}</span>
        </router-link-modified>
      </div>
    </div>

    <!--  MOBILE  -->
    <div class="subpages-tabs__navs-mob d-none d-sm-flex select-dropdown">
      <button class="subpages-tabs__navs-mob-trigger"
              type="button"
              @click.prevent="onOpen">
        <span>{{ $get(current, 'name') }}</span>
        <BaseSvg name="ico-arrow"/>
      </button>

      <transition name="dropdown">
        <div v-if="show"
             v-click-out="onClose"
             class="select-dropdown__dropdown">
          <button class="select-dropdown__close"
                  type="button"
                  @click.prevent="onClose">
            <BaseSvg name="ico-close"
                     width=".8rem"
                     height=".8rem"/>
          </button>

          <div class="select-dropdown__options">
            <router-link-modified v-for="item in routes"
                                  :key="item.id"
                                  :to="item.route"
                                  :class="{_active: isRouteNameMixin(item.route.name)}"
                                  class="subpages-tabs__navs-mob-item">
              <span>{{ item.name }}</span>
            </router-link-modified>
          </div>
        </div>
      </transition>
    </div>

    <!--  CONTENT  -->

    <div class="account-tabs__content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SubpagesTabs',
    props: {
      routes: Array
    },
    data() {
      return {
        show: false,
      }
    },
    computed: {
      current() {
        return this.routes.find(r => this.isRouteNameMixin(r.route.name))
      }
    },
    methods: {
      onOpen() {
        this.show = true
      },
      onClose() {
        this.show = false
      },
    }
  }
</script>

<style lang="less">

</style>
